/* global app, gui, moment */

app.controller('dialog_editShiftCtrl', ['$rootScope', '$scope', '$http', 'NetworkService','AtlasNotification', function ($rootScope, $scope, $http, NetworkService, AtlasNotification) {
        $scope.gui = {okButtonDisabled:true};
        $scope.position = {};
        
        $rootScope.$on("editShiftDialog", function(e,data){
            $scope.job = {};
            $scope.job.alle_schichten_start = "";
            $scope.job.alle_schichten_ende = "";
            $scope.job.shiftId = data.data.alle_schichten_id
            $scope.job.alle_schichten_beschreibung = data.data.alle_schichten_beschreibung;
            try{
                $scope.job.alle_schichten_start = moment(data.data.alle_schichten_start, "YYYY-MM-DD HH:mm:ss").toDate();
                $scope.job.alle_schichten_ende = moment(data.data.alle_schichten_ende, "YYYY-MM-DD HH:mm:ss").toDate();
            }catch(Exception){
                
            }
        })
        
        $scope.updateShift = function ()
        {
            var newShift = {
                start: moment($scope.job.alle_schichten_start).format("YYYY-MM-DD HH:mm:ss"),
                end: moment($scope.job.alle_schichten_ende).format("YYYY-MM-DD HH:mm:ss"),
                shiftName: $scope.job.alle_schichten_beschreibung,
                shiftId: $scope.job.shiftId
            };
            
            NetworkService.callOperation("updateShift", newShift, function(response){
                if(response.isSuccessfull()){
                    AtlasNotification.info("Schicht erfolgreich upgedatet.");
                    $rootScope.$emit("updateCalendar")
                }
            })
        }
    }])